export class ExternalTemplateExecuteResult {
  isComplete: boolean;
  registeredId: string;
  value: string;
}
